










































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextInput from "@/components/TextInput.vue";
import DropDownInput from "@/components/DropDownInput.vue";
import { categoryService } from "@/services/category.service";
import { Category } from '@/models/category.model';
import store from "@/store/store";

require("@/assets/css/modal.scss");

@Component(
    {
        components : {
            TextInput,
            DropDownInput
        }
    }
)
export default class PinboardModal extends Vue{
    @Prop() private id!: number;

    showContent:boolean = false;
    category:Category = {color:"#607D8B"};
    color:string = "";

    errors:string[] = [];

    close(){
        this.showContent = false;
        this.$emit("modalEmit", 'close');
    }

    async save(){
        store.dispatch("app/resetErrors");
        this.category.companyId = store.getters["app/companyId"];
        categoryService.create(this.category).then((response) => { 
            this.category.id = response.data;
            this.$emit("modalEmit", 'saved');
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Kategori skapad',
                duration: 5000,
                type: 'success',
            });

            this.$emit("modalEmit", 'saved', this.category.id);
        });
    }

    async update(){
        store.dispatch("app/resetErrors");
        categoryService.update(this.category).then((response) => { 
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Kategori uppdaterad',
                duration: 5000,
                type: 'success',
            });
            this.$emit("modalEmit", 'saved');
        });
    }

    colorSelection(val:any){
        this.category.color = val;
    }

    @Watch('id')
    async idChanged(){
        this.errors = [];
        if(this.id != 0)
            this.category = await categoryService.get(this.id);
        else
            this.category = {name:"", color:"#fff", companyId:store.getters["app/companyId"]};
    }
}
